const DB_SCHEMA_PATTERNS: RegExp[] = [
  /\bCREATE\s+TABLE\b/i,
  /\bALTER\s+TABLE\b/i,
  /\bDROP\s+TABLE\b/i,
  /\bCREATE\s+DATABASE\b/i,
  /\bDROP\s+DATABASE\b/i,
  /\bCREATE\s+(?:UNIQUE\s+)?INDEX\s+\w+\s+ON\b/i,
  /\bSHOW\s+(?:TABLES|COLUMNS|DATABASES|SCHEMAS)\b/i,
  /\binformation_schema\b/i,
  /\bDESCRIBE\s+\w+\b/i,
  /\bEXEC(?:UTE)?\s+sp_\w+/i,
  /\bINSERT\s+INTO\s+\w+\s*\(\s*\w+(?:\s*,\s*\w+)+\s*\)\s*VALUES\b/i,
];

const FILTERED_RESPONSE =
  "I'm sorry, I'm not able to provide that information.";

const CODE_BLOCK_LANGUAGES =
  'python|sql|js|javascript|ts|typescript|bash|sh|ruby|java|go|rust|cpp|c|r';
const CLOSED_CODE_BLOCK_PATTERN = new RegExp(
  '```(?:' + CODE_BLOCK_LANGUAGES + ')\\n[\\s\\S]*?```',
  'gi',
);
const OPEN_CODE_BLOCK_PATTERN = new RegExp(
  '```(?:' + CODE_BLOCK_LANGUAGES + ')[\\s\\S]*$',
  'i',
);

// Matches complete tool call tags: <tool_call> ... </tool_call> or <toot_call> ... </toot_call>
const CLOSED_TOOL_CALL_PATTERN =
  /<t(?:ool|oot)_call>[\s\S]*?<\/t(?:ool|oot)_call>/gi;
// Matches incomplete/streaming tool call tags (no closing tag yet)
const OPEN_TOOL_CALL_PATTERN = /<t(?:ool|oot)_call>[\s\S]*$/i;

export function stripCodeBlocks(text: string): string {
  if (!text) {
    return text;
  }

  // Strip complete (closed) code blocks first
  let result = text.replace(CLOSED_CODE_BLOCK_PATTERN, '');

  // Strip any remaining unclosed code block (partial streaming response)
  result = result.replace(OPEN_CODE_BLOCK_PATTERN, '');

  // Strip complete tool call tags
  result = result.replace(CLOSED_TOOL_CALL_PATTERN, '');

  // Strip any remaining incomplete/streaming tool call tag
  result = result.replace(OPEN_TOOL_CALL_PATTERN, '');

  return result.replace(/\n{3,}/g, '\n\n').trim();
}

export function filterDbSchemaLeakage(text: string): string {
  if (!text) {
    return text;
  }

  for (const pattern of DB_SCHEMA_PATTERNS) {
    if (pattern.test(text)) {
      return FILTERED_RESPONSE;
    }
  }

  return stripCodeBlocks(text);
}
